<svg class="dxc-state-icon" [class]="hostClasses" viewBox="0 0 96 96"
  [attr.role]="ariaLabel ? 'img' : null" [attr.aria-label]="ariaLabel || null"
  [attr.aria-hidden]="ariaLabel ? null : true" [style.--si-size.px]="size">
    @switch (name) {
            @case ('vehiculo-no-registrado') {
                <ng-container>
                    <path class="ln si-march" d="M8 34h46v26H8z"/>
                    <path class="ln si-march" d="M54 42h11l9 10v8H54z"/>
                    <circle class="sf" cx="24" cy="66" r="6"/><circle class="sf" cx="64" cy="66" r="6"/>
                    <path class="sf" d="M6 76h84"/>
                    <g class="si-pulse"><circle cx="76" cy="24" r="17" fill="var(--dxc-surface)"/><circle class="acf" cx="76" cy="24" r="14" opacity=".16"/><path class="ac" d="M76 17v14M69 24h14"/></g>
                </ng-container>
            }
            <!-- Hermano de `vehiculo-no-registrado`, y por eso comparte su
                 gramática: el objeto con el contorno que avanza dice «existe
                 pero no está dado de alta», y la chapa de acento que late dice
                 «dalo de alta». Lo que cambia es el objeto: aquí no es la
                 unidad, es la licencia — que es lo que el listado pide de un
                 conductor (número, vencimiento y estado de expedición). Un
                 monigote genérico serviría igual para un contacto o un
                 usuario; una licencia solo sirve para esto. -->
            @case ('conductor-no-registrado') {
                <ng-container>
                    <path class="ln si-march" d="M10 22h60a4 4 0 0 1 4 4v38a4 4 0 0 1-4 4H10a4 4 0 0 1-4-4V26a4 4 0 0 1 4-4z"/>
                    <circle class="sf" cx="27" cy="39" r="8"/>
                    <path class="sf" d="M16 58c1.9-6.6 6-9.9 11-9.9s9.1 3.3 11 9.9"/>
                    <path class="sf" d="M47 38h17M47 52h11"/>
                    <path class="sf" d="M6 76h84"/>
                    <g class="si-pulse"><circle cx="76" cy="24" r="17" fill="var(--dxc-surface)"/><circle class="acf" cx="76" cy="24" r="14" opacity=".16"/><path class="ac" d="M76 17v14M69 24h14"/></g>
                </ng-container>
            }
            @case ('vehiculo-no-encontrado') {
                <ng-container>
                    <g opacity=".4">
                    <path class="ln" d="M8 34h46v26H8z"/><path class="ln" d="M54 42h11l9 10v8H54z"/>
                    <circle class="ln" cx="24" cy="66" r="6"/><circle class="ln" cx="64" cy="66" r="6"/>
                    </g>
                    <path class="sf" d="M6 76h84"/>
                    <g class="si-sweep"><circle class="ac" cx="46" cy="44" r="16"/><path class="ac" d="M58 56l11 11"/></g>
                </ng-container>
            }
            @case ('datos-no-coinciden') {
                <ng-container>
                    <g class="si-recoil"><path class="ln" d="M5 14h46v25H5z"/><path class="sf" d="M12 24h32M12 32h18"/></g>
                    <g class="si-recoil-r"><path class="ln" d="M45 57h46v25H45z"/><path class="sf" d="M52 67h32M52 75h18"/></g>
                    <circle cx="48" cy="48" r="16" fill="var(--dxc-surface)"/>
                    <circle class="acf" cx="48" cy="48" r="13" opacity=".16"/>
                    <path class="ac" d="M43 43l10 10M53 43l-10 10"/>
                </ng-container>
            }
            @case ('sin-gps') {
                <ng-container>
                    <circle class="ac si-ring" cx="48" cy="42" r="6" fill="none"/>
                    <circle class="ac si-ring" cx="48" cy="42" r="6" fill="none" style="animation-delay:.75s"/>
                    <path class="ln" d="M48 20c-9.4 0-17 7.6-17 17 0 12.7 17 31 17 31s17-18.3 17-31c0-9.4-7.6-17-17-17z"/>
                    <circle class="sf" cx="48" cy="37" r="6"/>
                    <path class="ac" d="M28 70L68 24" stroke-width="2.8"/>
                </ng-container>
            }
            @case ('sin-timbrar') {
                <ng-container>
                    <path class="ln" d="M20 12h34l16 16v56H20z"/>
                    <path class="sf" d="M54 12v16h16M30 48h28M30 58h18"/>
                    <g class="si-bob"><circle class="ac si-march" cx="68" cy="68" r="15"/><path class="ac" d="M61 68l5 5 10-11"/></g>
                </ng-container>
            }
            @case ('timbrado-ok') {
                <ng-container>
                    <circle class="ac si-draw" cx="48" cy="48" r="30" style="--len:190" transform="rotate(-90 48 48)"/>
                    <path class="ac si-draw si-draw--2" d="M34 49l10 10 19-22" style="--len:48"/>
                </ng-container>
            }
            @case ('pac-rechazo') {
                <ng-container>
                    <g class="si-tilt"><path class="ln" d="M18 12h34l16 16v50H18z"/><path class="sf" d="M52 12v16h16M28 46h26M28 56h16"/></g>
                    <circle cx="70" cy="70" r="18" fill="var(--dxc-surface)"/>
                    <circle class="acf" cx="70" cy="70" r="15" opacity=".16"/>
                    <path class="ac" d="M64 64l12 12M76 64l-12 12"/>
                </ng-container>
            }
            @case ('ruta-sin-transportista') {
                <ng-container>
                    <circle class="acf" cx="18" cy="72" r="7"/>
                    <path class="ac si-flow" d="M18 72C36 72 40 46 58 40"/>
                    <g class="si-pulse"><path class="ln si-march" d="M72 18a13 13 0 0 1 13 13c0 9-13 22-13 22S59 40 59 31a13 13 0 0 1 13-13z"/></g>
                    <path class="sf" d="M6 84h84"/>
                </ng-container>
            }
            @case ('sin-cargas') {
                <ng-container>
                    <g class="si-bob">
                    <path class="ln" d="M20 42h56v34H20z"/>
                    <path class="sf" d="M20 42l-9-13h31l6 13"/>
                    <path class="sf" d="M76 42l9-13H54l-6 13"/>
                    </g>
                    <path class="sf" d="M8 84h80"/>
                </ng-container>
            }
            <!-- Sin avisos. La familia dice el estado con lo que le FALTA al
                 objeto, no con una prohibición encima: `sin-cargas` es la caja
                 abierta y vacía, no una caja tachada. Aquí el objeto es la
                 campana y lo que le falta es el sonido, así que la campana
                 queda quieta —sin `si-bob`, que la haría sonar y diría lo
                 contrario— apoyada en la línea de suelo de la familia, y los
                 dos arcos que el sonido dibujaría se quedan tenues y latiendo:
                 no es que no haya campana, es que no ha llegado nada todavía.
                 Congelados por `prefers-reduced-motion` el dibujo se sostiene
                 igual — arcos apagados es exactamente lo que significa. -->
            @case ('sin-avisos') {
                <ng-container>
                    <path class="ln" d="M48 22a17.5 17.5 0 0 0-17.5 17.5c0 13.6-4.9 17.5-4.9 17.5h44.8s-4.9-3.9-4.9-17.5A17.5 17.5 0 0 0 48 22z"/>
                    <path class="ln" d="M41.6 64.4a6.8 6.8 0 0 0 12.8 0"/>
                    <path class="sf" d="M48 22v-6.4"/>
                    <g class="si-pulse">
                        <path class="sf" d="M20.5 40.5a28 28 0 0 1 9.4-19.6"/>
                        <path class="sf" d="M75.5 40.5a28 28 0 0 0-9.4-19.6"/>
                    </g>
                    <path class="sf" d="M8 84h80"/>
                </ng-container>
            }
            <!-- Sin adjuntos. Misma familia que `sin-cargas` y `sin-avisos`: el
                 estado lo dice lo que al objeto le FALTA, no una prohibición
                 encima. La bandeja está ahí, apoyada en la línea de suelo de la
                 familia, y lo que falta es lo que va dentro — así que el hueco
                 del documento se dibuja con el contorno discontinuo, que en el
                 producto ya significa «suelta aquí» desde `.dxc-dropzone`.

                 Dos cosas de §6 que decidieron el dibujo:

                 · **El fotograma cero también significa.** La hoja no nace
                   invisible para aparecer: nace dibujada y en su sitio, y lo
                   único que la animación mueve es su altura. Congelada por
                   `prefers-reduced-motion` el dibujo dice lo mismo —bandeja
                   vacía, hueco esperando—, que es el criterio para aceptar un
                   icono nuevo en esta familia.

                 · **Aire entre las partes.** Seis unidades de rejilla entre la
                   base de la hoja y el canto de la bandeja: a 44px —el tamaño
                   de una alerta— con dos se tocaban y se leían como una sola
                   caja. -->
            @case ('sin-adjuntos') {
                <ng-container>
                    <g class="si-bob">
                        <path class="sf si-march" d="M34 10h17l11 11v21H34z"/>
                        <path class="sf" d="M51 10v11h11"/>
                    </g>
                    <path class="ln" d="M30 48h36l10 18v5a5 5 0 0 1-5 5H25a5 5 0 0 1-5-5V66z"/>
                    <path class="ln" d="M20 66h13l4 7h22l4-7h13"/>
                    <path class="sf" d="M8 84h80"/>
                </ng-container>
            }
            <!-- Sin tarifa. Misma familia que `sin-cargas`, `sin-avisos` y
                 `sin-adjuntos`: el estado lo dice lo que al objeto le FALTA, no
                 una prohibición encima. El objeto es la **etiqueta de tarifa**
                 —el sitio donde se escribe lo que vale el flete—, y lo que le
                 falta es la cifra: por eso la etiqueta va sólida (existe: el
                 flete está ahí y su renglón espera) y son los dos renglones del
                 importe los que van punteados.

                 **No es `sin-ofertas`, y la frontera es exacta.** Una etiqueta
                 dice el PRECIO DE LA COSA; una oferta es alguien PROPONIENDO un
                 precio por un viaje, que es un acto entre dos partes y no un
                 atributo del objeto. Se dibujó primero para el hueco de
                 «Ofertas» y ahí decía lo que no era.

                 Se descartó el inverso —etiqueta punteada, renglones sólidos—
                 mirando la lámina y no el código: a 44px la silueta punteada se
                 disuelve y el glifo deja de leerse, mientras que la sólida
                 aguanta hasta los 30. Es la comprobación de §6 (104/30/17), que
                 aquí además destapó que la primera versión —hombros redondeados
                 y punta abajo— se leía como un **escudo**; la punta arriba con
                 el ojal es lo que la convierte en etiqueta.

                 La animación es el mecerse, no un parpadeo: una etiqueta colgada
                 del riel y con el importe en blanco es exactamente «esto todavía
                 no tiene tarifa». Su reposo es colgar recta —`si-swing`
                 arranca y termina en `rotate(0)`—, así que `prefers-reduced-motion`
                 la congela en el fotograma que ya significa (R13). -->
            @case ('sin-tarifa') {
                <ng-container>
                    <path class="sf" d="M30 8h36"/>
                    <g class="si-swing">
                        <path class="sf" d="M48 8v7"/>
                        <path class="ln" d="M48 15 71 35a4 4 0 0 1 1.4 3v25a4 4 0 0 1-4 4H27.6a4 4 0 0 1-4-4V38a4 4 0 0 1 1.4-3z"/>
                        <circle class="sf" cx="48" cy="32" r="4.4"/>
                        <path class="sf si-march" d="M33 48h30M33 58h19"/>
                    </g>
                    <path class="sf" d="M8 84h80"/>
                </ng-container>
            }
            <!-- Sin ofertas. Una oferta no es un atributo del flete, es un
                 ACTO entre dos partes: alguien propone un precio por un viaje.
                 Por eso el dibujo tiene las dos mitades de esa frase y no una
                 sola cosa — abajo el viaje (origen lleno, ruta, destino todavía
                 hueco) y arriba el globo en el que se dice la cifra, con el
                 renglón del importe **en blanco**. Es la gramática de la familia
                 otra vez: el globo va sólido porque el sitio para proponer
                 existe —el flete está publicado—, y lo punteado es lo que falta.

                 La ruta va **arqueada** y no recta, y no es adorno: con dos
                 nudos unidos por un segmento horizontal el conjunto se leía como
                 el **control deslizante** de un filtro. El arco lo convierte en
                 un trayecto.

                 Un solo renglón dentro del globo, no dos. Con dos se leía como
                 un mensaje de chat —que es justo lo que dibuja el icono
                 `mensaje`—, y aquí lo que se espera es una cifra, no un texto.

                 El destino va hueco y el origen lleno: el viaje tiene punto de
                 partida y todavía no tiene quién lo cierre. -->
            @case ('sin-ofertas') {
                <ng-container>
                    <g class="si-bob">
                        <path class="ln" d="M26 12h44a8 8 0 0 1 8 8v26a8 8 0 0 1-8 8H55l-7 9-7-9H26a8 8 0 0 1-8-8V20a8 8 0 0 1 8-8z"/>
                        <path class="sf si-march" d="M30 33h36"/>
                    </g>
                    <circle class="si-node" cx="20" cy="76" r="4.6"/>
                    <path class="sf" d="M25 76c12-9 34-9 46 0"/>
                    <circle class="sf" cx="76" cy="76" r="4.6"/>
                    <path class="sf" d="M8 88h80"/>
                </ng-container>
            }
            <!-- Sin pólizas. Reverso del glifo `poliza`: la unidad existe y lo que falta
     es la cobertura, así que el toldo y el asta van punteados. -->
            @case ('sin-polizas') {
                <ng-container>
                    <path class="sf si-march" d="M10 30a32 20 0 0 1 64 0z"/>
                    <path class="sf" d="M42 10V5"/>
                    <path class="sf si-march" d="M42 30v13"/>
                    <path class="ln" d="M12 48h42v22H12z"/>
                    <path class="ln" d="M54 55h10l8 8v7H54z"/>
                    <circle class="sf" cx="26" cy="75.5" r="5.5"/><circle class="sf" cx="62" cy="75.5" r="5.5"/>
                    <path class="sf" d="M8 84h80"/>
                </ng-container>
            }
            <!-- Póliza sin unidades. Par de `sin-polizas` con los papeles cambiados. La
     unidad punteada va en `ln` y sin latido para no desaparecer a 44px; es la
     excepción a «se puntea la parte», porque aquí falta la unidad entera. -->
            @case ('poliza-sin-unidades') {
                <ng-container>
                    <path class="ln" d="M10 30a32 20 0 0 1 64 0z"/>
                    <path class="ln" d="M42 10V5"/>
                    <path class="ln" d="M42 30v13"/>
                    <path class="ln si-march" d="M12 48h42v22H12z"/>
                    <path class="ln si-march" d="M54 55h10l8 8v7H54z"/>
                    <circle class="sf" cx="26" cy="75.5" r="5.5"/><circle class="sf" cx="62" cy="75.5" r="5.5"/>
                    <path class="sf" d="M8 84h80"/>
                </ng-container>
            }
            <!-- Sin prima. La cobertura existe y su costo no está escrito: el medallón
     del importe va punteado. No es `sin-tarifa`, que es el precio de un flete. -->
            @case ('sin-prima') {
                <ng-container>
                    <path class="ln" d="M16 36a32 20 0 0 1 64 0z"/>
                    <path class="ln" d="M48 16v-6"/>
                    <path class="ln" d="M48 36v12"/>
                    <path class="ln" d="M20 52h56a4 4 0 0 1 4 4v20a4 4 0 0 1-4 4H20a4 4 0 0 1-4-4V56a4 4 0 0 1 4-4z"/>
                    <circle class="sf si-march" cx="48" cy="66" r="8"/>
                    <path class="sf" d="M25 60h7M64 72h7"/>
                    <path class="sf" d="M8 88h80"/>
                </ng-container>
            }
            <!-- Sin renovaciones. Renovar crea una póliza nueva sin tocar la vieja: la
     vigente sólida, la siguiente punteada y, entre ambas, la flecha de acento,
     que es la causa —la renovación que todavía no ocurre—. -->
            @case ('sin-renovaciones') {
                <ng-container>
                    <path class="ln" d="M10 34h26l10 10v38H10z"/>
                    <path class="sf" d="M36 34v10h10M18 56h20M18 66h14"/>
                    <path class="sf si-march" d="M52 18h24l10 10v38H52z"/>
                    <path class="sf si-march" d="M76 18v10h10"/>
                    <g class="si-bob"><path class="ac si-flow" d="M22 26c4-12 18-18 28-14"/><path class="ac" d="m44 7 6 5-7 3"/></g>
                    <path class="sf" d="M6 88h84"/>
                </ng-container>
            }
            <!-- Sin acceso. El rack de `administracion` con el candado en la chapa de la
     familia. Tono `danger` por defecto: la vista bloquea (§5). En reposo el
     candado sigue cerrado, que es lo que dice. -->
            @case ('sin-acceso') {
                <ng-container>
                    <path class="ln" d="M16 16h56a4 4 0 0 1 4 4v16a4 4 0 0 1-4 4H16a4 4 0 0 1-4-4V20a4 4 0 0 1 4-4z"/>
                    <path class="ln" d="M16 46h56a4 4 0 0 1 4 4v16a4 4 0 0 1-4 4H16a4 4 0 0 1-4-4V50a4 4 0 0 1 4-4z"/>
                    <path class="sf" d="M22 28h22M22 58h22"/>
                    <circle class="si-node" cx="62" cy="28" r="3"/><circle class="si-node" cx="62" cy="58" r="3"/>
                    <path class="sf" d="M8 84h56"/>
                    <g class="si-recoil">
                        <circle cx="72" cy="70" r="18" fill="var(--dxc-surface)"/>
                        <circle class="acf" cx="72" cy="70" r="15" opacity=".16"/>
                        <path class="ac" d="M64.5 69h15a1.5 1.5 0 0 1 1.5 1.5v8a1.5 1.5 0 0 1-1.5 1.5h-15a1.5 1.5 0 0 1-1.5-1.5v-8a1.5 1.5 0 0 1 1.5-1.5z"/>
                        <path class="ac" d="M67 69v-4a5 5 0 0 1 10 0v4"/>
                    </g>
                </ng-container>
            }
            <!-- Sin duplicados. Contrario de `datos-no-coinciden`: las fichas quedan
     separadas —el hueco dice «no son la misma»— y la chapa lleva la palomita
     en `success`. Sin línea de suelo, como su hermano. -->
            @case ('sin-duplicados') {
                <ng-container>
                    <path class="ln" d="M6 22h36v24H6z"/><path class="sf" d="M12 31h24M12 38h14"/>
                    <path class="ln" d="M54 22h36v24H54z"/><path class="sf" d="M60 31h24M60 38h14"/>
                    <circle cx="48" cy="66" r="16" fill="var(--dxc-surface)"/>
                    <circle class="acf si-pulse" cx="48" cy="66" r="13" opacity=".16"/>
                    <path class="ac" d="m41 66 5 5 9-10"/>
                </ng-container>
            }
            <!-- Sin movimientos. La ficha de `puntos` bajo los renglones punteados del
     historial: la cuenta existe y faltan los movimientos. La estrella va en
     `ln` porque en `sf` se perdía a 44px. -->
            @case ('sin-movimientos') {
                <ng-container>
                    <circle class="sf" cx="44" cy="18" r="2.6"/><path class="sf si-march" d="M52 18h30"/>
                    <circle class="sf" cx="44" cy="32" r="2.6"/><path class="sf si-march" d="M52 32h22"/>
                    <circle class="sf" cx="44" cy="46" r="2.6"/><path class="sf si-march" d="M52 46h26"/>
                    <g class="si-bob">
                        <circle class="ln" cx="26" cy="62" r="16"/>
                        <path class="ln" d="m26 53 2.6 5.3 5.9.9-4.3 4.1 1 5.8-5.2-2.7-5.2 2.7 1-5.8-4.3-4.1 5.9-.9z"/>
                    </g>
                    <path class="sf" d="M8 88h80"/>
                </ng-container>
            }
            <!-- Conductor no encontrado. La familia «no encontrado» ya existía para la
     unidad: lo constante es el objeto atenuado con la lupa que barre, y lo
     que cambia es el objeto, aquí la licencia de `conductor-no-registrado`. -->
            @case ('conductor-no-encontrado') {
                <ng-container>
                    <g opacity=".4">
                        <path class="ln" d="M10 22h60a4 4 0 0 1 4 4v38a4 4 0 0 1-4 4H10a4 4 0 0 1-4-4V26a4 4 0 0 1 4-4z"/>
                        <circle class="ln" cx="27" cy="39" r="8"/>
                        <path class="ln" d="M16 58c1.9-6.6 6-9.9 11-9.9s9.1 3.3 11 9.9"/>
                        <path class="ln" d="M47 38h17M47 52h11"/>
                    </g>
                    <path class="sf" d="M6 76h84"/>
                    <g class="si-sweep"><circle class="ac" cx="46" cy="44" r="16"/><path class="ac" d="M58 56l11 11"/></g>
                </ng-container>
            }
            <!-- Sin facturas. El complemento de pago existe —va sólido, con su
     pliegue y sus renglones—; lo que le falta son las facturas que ampara, y
     esas van punteadas en `ln` y no en `sf` porque lo que falta es el objeto
     entero (a 44px el trazo tenue se disolvía). La flecha de acento es la
     llamada: la factura entra por su XML. No es `sin-adjuntos`: aquello es una
     bandeja esperando un archivo cualquiera; esto es un documento fiscal
     esperando los documentos que liquida. -->
            @case ('sin-facturas') {
                <ng-container>
                    <path class="ln" d="M12 34h30l10 10v40H12z"/>
                    <path class="sf" d="M42 34v10h10M20 56h24M20 66h16"/>
                    <path class="ln si-march" d="M60 44h18l8 8v32H60z"/>
                    <g class="si-bob"><path class="ac" d="M73 10v20M66 23l7 7 7-7"/></g>
                    <path class="sf" d="M6 88h84"/>
                </ng-container>
            }
            @case ('sin-conexion') {
                <ng-container>
                    <path class="acf" d="M15.86 6.6c-0.73 0.3-1.93 1.24-2.66 2.1-1.63 1.89-2.01 3.9-1.76 9.47 0.13 3.39 0.34 4.24 1.2 5.57 1.63 2.4 3.86 3.26 8.4 3.26 15.39 0.09 20.87 5.61 20.83 21 0 8.96-1.37 13.37-5.14 16.8-2.96 2.7-8.87 4.2-16.33 4.2-4.33-0-6.6 1.11-8.1 3.9-0.94 1.76-0.99 2.27-0.86 7.11 0.13 5.06 0.17 5.23 1.46 6.86 2.19 2.74 3.43 3.13 9.81 3.13 4.5-0 5.91-0.17 7.29-0.81 3.34-1.54 4.46-3.9 4.5-9.51 0-6.09 1.84-10.67 5.96-14.87 3.81-3.9 8.31-5.83 14.91-6.34 6.9-0.51 7.41-1.24 7.41-10.46 0-9.43-0.6-10.2-8.1-10.71-6.43-0.47-9.47-1.76-13.93-5.96-4.33-4.11-5.83-7.67-6.26-14.83-0.34-5.79-0.86-7.2-3.3-9.09-1.54-1.16-1.71-1.2-7.8-1.29-4.54-0.09-6.6 0.04-7.54 0.47z"/>
                    <path class="acf" d="M15.51 37.33c-0.86 0.47-2.1 1.63-2.79 2.61-1.11 1.76-1.16 1.93-1.16 8.06 0 6.13 0.04 6.3 1.2 8.06 1.93 2.96 3.56 3.51 10.37 3.51 6.81-0 8.44-0.56 10.37-3.51 1.16-1.76 1.2-1.93 1.2-8.06 0-6.13-0.04-6.3-1.2-8.06-1.97-3-3.56-3.51-10.46-3.51-5.06 0.04-6.17 0.17-7.54 0.9z"/>
                    <path class="ln si-march" fill="none" d="M45.39 6.6c-0.73 0.3-1.76 1.16-2.27 1.89-0.81 1.16-0.9 1.84-0.9 6.6 0 6.13 0.64 8.06 3.21 10.03 1.46 1.11 2.06 1.24 6.94 1.63 4.97 0.39 5.49 0.34 6.9-0.43 2.87-1.59 3.3-2.61 3.21-8.01-0.13-6.86-1.41-9.56-5.27-11.19-2.27-0.94-10.16-1.29-11.83-0.51z"/>
                    <path class="ln si-march" fill="none" d="M47.66 70.07c-0.94 0.3-2.14 1.03-2.74 1.59-2.01 1.84-2.4 3.26-2.61 8.66-0.21 6 0.26 7.5 3.04 8.91 1.5 0.73 2.19 0.81 5.61 0.56 5.14-0.39 6.81-0.86 8.57-2.4 2.01-1.76 2.79-4.03 3.13-9.09 0.26-4.89-0.13-6.3-2.27-7.97-1.03-0.81-1.71-0.9-6.13-0.9-3.09 0.04-5.61 0.26-6.6 0.64z"/>
                    <path class="ln si-march" fill="none" d="M71.7 38.79c-2.36 1.33-2.91 3.34-2.91 10.2 0 5.7 0.09 6.3 0.99 7.63 1.54 2.36 3.26 2.96 7.33 2.66 6.39-0.47 7.54-2.1 7.54-10.59 0-5.96-0.6-7.97-2.74-9.39-1.59-1.07-8.66-1.41-10.2-0.51z"/>
                </ng-container>
            }
    }
</svg>
